/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { GET_DEFECT_HISTORY_BY_FACILITY } from '../queries/defect-history.queries';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject } from 'rxjs';
import { HbgSnackBar } from 'src/app/shared/toaster/hbg-toaster';

@Injectable({
  providedIn: 'root',
})
export class DefectHistoryService {

    //defect history data by facility number and date
    private defectHistoryData = new BehaviorSubject<any[]>([]);
    defectHistoryData$ = this.defectHistoryData.asObservable();

    constructor(private apolloClient: Apollo, private toaster: HbgSnackBar) {}

    getDefectHistory(facilityNumber: string, startDate: string, endDate: string) {
        this.apolloClient
        .query({
            query: GET_DEFECT_HISTORY_BY_FACILITY,
            variables: {
                userFacility: facilityNumber,
                startDate: startDate,
                endDate: endDate
            },
        })
        .subscribe({
            next: (response: any) => {
                console.log('response',response);
                if(response.data.GetDefectHistory.Success === true) {
                    const result = response.data.GetDefectHistory;
                    const records = result?.Data ? JSON.parse(result.Data) : [];
                    this.defectHistoryData.next(records);
                } else {
                    this.toaster.stickyError(
                        `Error fetching defect history: ${response.data.GetDefectHistory.Message} - ${new Date().toLocaleString()}`
                    );
                    this.defectHistoryData.next([]);
                }
            },
            error: (err) => {
                this.toaster.stickyError(
                    `Error fetching defect history: ${err} - ${new Date().toLocaleString()}`
                );
                this.defectHistoryData.next([]);
            }
        });
    }
}